/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminCreate } from '../models/AdminCreate';
import type { AdminDetails } from '../models/AdminDetails';
import type { AdminUpdateDTO } from '../models/AdminUpdateDTO';
import type { UserLoginAttemptDetails } from '../models/UserLoginAttemptDetails';
import { request as __request } from '../core/request';

export class AdminsVService {

    /**
     * @param operatorId
     * @param userRoleId
     * @param name
     * @param email
     * @param isActive
     * @param fromCreatedAt
     * @param toCreatedAt
     * @param createdBy
     * @returns AdminDetails OK
     * @throws ApiError
     */
    public static async adminsVGetAll(
        operatorId: string,
        userRoleId?: number,
        name?: string,
        email?: string,
        isActive?: boolean,
        fromCreatedAt?: string,
        toCreatedAt?: string,
        createdBy?: string,
    ): Promise<Array<AdminDetails>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v1/admins`,
            query: {
                'OperatorId': operatorId,
                'UserRoleId': userRoleId,
                'Name': name,
                'Email': email,
                'IsActive': isActive,
                'FromCreatedAt': fromCreatedAt,
                'ToCreatedAt': toCreatedAt,
                'CreatedBy': createdBy,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AdminDetails Created
     * @throws ApiError
     */
    public static async adminsVAdminCreate(
        requestBody?: AdminCreate,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/admins`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @returns AdminDetails OK
     * @throws ApiError
     */
    public static async adminsVGetById(
        userId: string,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v1/admins/${userId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @param requestBody
     * @returns AdminDetails OK
     * @throws ApiError
     */
    public static async adminsVUpdate(
        userId: string,
        requestBody?: AdminUpdateDTO,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'PUT',
            path: `/api/v1/admins/${userId}`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @returns any No Content
     * @throws ApiError
     */
    public static async adminsVDelete(
        userId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v1/admins/${userId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @returns UserLoginAttemptDetails OK
     * @throws ApiError
     */
    public static async adminsVGetLoginAttemptsById(
        userId: string,
    ): Promise<Array<UserLoginAttemptDetails>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v1/admins/${userId}/LoginAttempts`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}